import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isVideo',
  standalone: true,
})
export class IsVideoPipe implements PipeTransform {
  transform(url: string | null | undefined): boolean {
    if (!url) return false;
    return /\.(mp4|mov|webm|avi|mkv|ogg)(\?.*)?$/i.test(url);
  }
}
